import { type ReactElement } from "react"
import cardsVerticalMobile from "~/images/landing/cards-vertical.png"
import cardsVerticalTablet from "~/images/landing/cards-vertical@2x.png"
import cardsVerticalDesktop from "~/images/landing/cards-vertical@3x.png"
import cardsHorizontalTablet from "~/images/landing/cards-horizontal@2x.png"
import { ResponsiveImage, BREAKPOINTS } from "../common/responsive-image"

function HeaderImageDesktop(): ReactElement {
  return (
    <ResponsiveImage
      sources={[
        { media: BREAKPOINTS.mobile, src: cardsVerticalMobile },
        { media: BREAKPOINTS.tablet, src: cardsVerticalTablet },
        { media: BREAKPOINTS.desktop, src: cardsVerticalDesktop },
      ]}
      fallbackSrc={cardsVerticalMobile}
      alt="Cards"
      className="hidden w-full max-w-md md:block md:max-h-[900px] md:max-w-[600px]"
    />
  )
}

export function HeaderImageMobile(): ReactElement {
  return (
    <ResponsiveImage
      sources={[
        { media: BREAKPOINTS.mobile, src: cardsHorizontalTablet },
        { media: BREAKPOINTS.tablet, src: cardsHorizontalTablet },
      ]}
      fallbackSrc={cardsHorizontalTablet}
      alt="Cards"
      className="w-full md:hidden"
    />
  )
}

export function HeaderImage() {
  return (
    <div className="md:block">
      <HeaderImageDesktop />
    </div>
  )
}
